<section id="notesAndAttachments">
  <nz-card>

    <div [ngClass]="!loading ? 'block' : 'hidden'" class="mt-5 grid md:grid-cols-1 xl:grid-cols-2 gap-8 mb-10">

      <div *appHasAnyPrivilege="'NOTES_ATTACHMENTS_NOTES_VIEW'">
        <div class="flex -align-center mb-5">
          <p class="font-semibold mr-5">Notes</p>
          <span *appHasAnyPrivilege="'NOTES_ATTACHMENTS_NOTES_UPDATE'" nz-icon nzType="edit" (click)="showModal()"
                class="mt-0.5 clickable-element" nzTheme="outline"></span>
        </div>
        <textarea class="mt-2" rows="8" nz-input id="disabledTextarea" disabled [(ngModel)]="inputValue"></textarea>

        <nz-divider></nz-divider>
        <div class="flex flex-col mb-5">
          <p class="font-semibold mr-5 mb-3">Remarks</p>
          <div *ngFor="let remark of remarks">
            <div class="grid grid-cols-12">
              <div class="col-span-12 md:col-span-3">
                <p class="text-sm hidden md:block"> {{remark.createdAt | date: 'dd-MM-y'}}</p>
                <p class="text-sm hidden md:block"> {{remark.createdAt | date: 'hh:mm aa'}}</p>
                <p class="text-sm block md:hidden"> {{remark.createdAt | date: 'dd-MM-y | hh:mm aa'}}</p>
              </div>
              <div class="col-span-12 md:col-span-9">
                <p class="text-black">{{remark.description}}</p>
                <p
                  class="text-sm text-gray-500">{{ remark.action + ' by ' + remark.createdUser + ' (' + (remark.createdUserRole | titlecase) + ')' }}</p>
              </div>
            </div>
            <nz-divider class="my-2"></nz-divider>
          </div>
          <div class="grid grid-cols-3 mt-2 content-center">
            <p class="text-sm mx-2" *ngIf="!remarks === null || remarks.length < 1">
            </p>
            <p class="text-sm mx-2 mt-4" *ngIf="!remarks === null || remarks.length < 1">No
              Data</p>
            <p class="text-sm mx-2" *ngIf="!remarks === null || remarks.length < 1">
            </p>
          </div>
        </div>
      </div>

      <div *appHasAnyPrivilege="'NOTES_ATTACHMENTS_ATTACHMENT_VIEW'" class="sub-section" style="height: 100%">
        <div class="flex justify-between items-center flex-col md:flex-row">
          <p class="font-semibold mb-2 md:mb-0">Attachments</p>
          <nz-upload [nzCustomRequest]="upload" [nzShowUploadList]="false" [nzMultiple]="true">
            <button *appHasAnyPrivilege="'NOTES_ATTACHMENTS_ATTACHMENT_CREATE'" nz-button nzType="primary">Add
              Attachment
            </button>
          </nz-upload>
        </div>
        <nz-divider></nz-divider>
        <div>
          <div>
            <p class="text-primary items-center mx-3 gap-5"  *ngIf="uploading">Uploading...</p>
            <div class="mb-3 flex  items-center mx-3 gap-5" *ngFor="let item of this.files; let i = index">
              <a target="_blank" href="{{item.url}}">{{item.name}}</a>
              <span *appHasAnyPrivilege="'NOTES_ATTACHMENTS_ATTACHMENT_DELETE'" nz-icon nzType="close-circle"
                    nzTheme="outline" [nzTheme]="'twotone'" [nzTwotoneColor]="'#ff0000'"
                    class="cursor-pointer" nz-popconfirm
                    nzPopconfirmTitle="Are you sure you want to delete this attachment"
                    (nzOnConfirm)="confirmRemoveAttachment(i)"
              ></span>
            </div>
          </div>
<!--          <div *ngIf="uploading" class="flex justify-center">-->
<!--            <p class="text-primary">Uploading...</p>-->
<!--          </div>-->

        </div>
      </div>


    </div>

    <div [ngClass]="loading ? 'block' : 'hidden'">
      <app-single-view-skeleton-template [typeName]="'note-view'"></app-single-view-skeleton-template>
    </div>

  </nz-card>
</section>


<nz-modal
  [(nzVisible)]="isVisible"
  [nzTitle]="modalTitle"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  (nzOnCancel)="handleCancel()"
>
  <ng-template #modalTitle>Create Note</ng-template>

  <ng-template #modalContent>
    <textarea class="mt-2" rows="5" nz-input class="mt-5 mb-5" [(ngModel)]="tempInputVal"></textarea>
  </ng-template>

  <ng-template #modalFooter>
    <button nz-button class="outline-button" (click)="handleCancel()">Cancel</button>
    <button nz-button nzType="primary" (click)="handleOk()" [nzLoading]="loading">Update</button>
  </ng-template>
</nz-modal>
